import React, { useEffect, useState } from 'react';

import { ModalVideoTags } from 'lib/components/modal/ModalVideoTags';
import { Tag } from 'react-covideo-common';
import { useAuth } from 'lib/context';
import {
  productFeature,
  checkIfFeatureIsEnabled,
} from 'lib/utils/productFeature';
import { Button } from 'react-covideo-common';
import { useFormikContext } from 'formik';
import { Gap, Stack } from 'lib/components/styles/layout';
import { DetailsPreviewRecordFormValues, VideoTagOption } from '../types';
import { MdDeleteForever } from 'react-icons/md';
import { FaHashtag } from 'react-icons/fa';
import { useTranslation } from 'react-i18next';
import { useCDK } from 'lib/hooks/useCdk';

export const DetailsRecordPreviewTags = ({
  onDiscardHandler,
}: {
  onDiscardHandler: () => void;
}) => {
  const { t } = useTranslation();
  const { destructiveToText } = useCDK();
  const { values, setFieldValue } =
    useFormikContext<DetailsPreviewRecordFormValues>();
  const { userData } = useAuth();
  const [showModal, setShowModal] = useState(false);

  const openModal = () => {
    setShowModal(true);
  };

  const closeModal = () => {
    setShowModal(false);
  };

  const onSave = (values: VideoTagOption[]) => {
    setFieldValue('videoTags', values);
    closeModal();
  };

  const [isTagFeatureAvailable, setIsTagFeatureAvailable] = useState(true);

  useEffect(() => {
    const isTagEnabled = checkIfFeatureIsEnabled(
      userData,
      productFeature.VIDEO_TAGS
    );
    setIsTagFeatureAvailable(isTagEnabled);
  }, []);

  return (
    <Stack alignItems='flex-start' width='100%' m='32px 0 32px 0'>
      <Gap width='100%' justifyContent='space-between'>
        <Button
          variant={destructiveToText}
          icon={<MdDeleteForever size={18} />}
          text={t('Remove this video')}
          onClick={onDiscardHandler}
        />
        {isTagFeatureAvailable && (
          <Button
            variant='secondary'
            icon={<FaHashtag size={'16px'} />}
            text={t('Add Tags...')}
            onClick={openModal}
          />
        )}
      </Gap>
      {!!values?.videoTags?.length && (
        <Gap gap='4px' m='4px 0 0 0'>
          {values?.videoTags?.map(tag => (
            <Tag key={tag.value} tag={tag} />
          ))}
        </Gap>
      )}
      {showModal && (
        <ModalVideoTags
          videoTags={values?.videoTags}
          handleModalClose={closeModal}
          onSubmit={onSave}
          title={t('Manage Tags')}
          buttonTitle={t('Save Changes')}
        />
      )}
    </Stack>
  );
};
